import md5 from 'md5';
import { api } from './Api';
import camelToSnake from '../utils/CaseUtils/camelToSnake';
import {
  authHubLogin,
  authHubGetEatzyToken,
  authHubGetMe,
  authHubForgotPassword,
  authHubResetPassword,
} from './AuthHubService';

export const postLogin = async ({ email, password }) => {
  let sessionToken = null;
  try {
    sessionToken = await authHubLogin(email, password);
  } catch (err) {
    if (err.status && err.status < 500) {
      throw new Error('Invalid email or password');
    }
  }

  const eatzyAuth = await authHubGetEatzyToken(email, password);

  return {
    ...eatzyAuth,
    sessionToken,
  };
};

export const registerAccount = async ({
  username,
  firstname,
  lastname,
  password,
  email,
  source,
  profile,
  phone,
}) => {
  const response = await api.post('/account/register', {
    username,
    firstname,
    lastname,
    password: md5(password),
    email,
    source,
    profile,
    phone,
  });
  return response;
};

export const fetchRefreshToken = async (refreshToken) => {
  const response = await api.post(
    '/account/refresh',
    {},
    {
      refreshToken,
      hasRefreshToken: true,
    }
  );
  return response;
};

export const deauthorizeAccount = async (refreshToken) => {
  const response = await api.post(
    '/account/deauthorize',
    {},
    {
      refreshToken,
      hasRefreshToken: true,
    }
  );
  return response;
};

export const getMe = async (sessionToken) => {
  if (sessionToken) {
    try {
      return await authHubGetMe(sessionToken);
    } catch (_) {
      // Fall through to Eatzy API fallback
    }
  }
  const response = await api.get('/account/profile');
  return response;
};

export const forgotPassword = async (email, redirectUrl) => {
  return authHubForgotPassword(email, redirectUrl);
};

export const resetPassword = async ({ token, password }) => {
  return authHubResetPassword(token, password);
};
